import React, { useState } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { routePaths } from '../../../../routePaths';
import { FullScreenDialog } from '../../../../ui-kit';
import { DeliveryListComponent } from '../../../../generated/graphql';
import { useWarehousesScope } from '../../../warehouse/providers/WarehouseScopeProvider';
import DeliveryListDetailsView from './DeliveryListDetailsView';

const DeliveryListDetails = () => {
    const [isDialogOpened, setIsDialogOpened] = useState(true);
    const history = useHistory();
    const { params: { id: deliveryListId } } = useRouteMatch();
    const { currentWarehouseId } = useWarehousesScope();

    const onClose = () => {
        setIsDialogOpened(false);
        history.push(routePaths.warehouseDeliveryLists);
    };

    return (
        <FullScreenDialog isOpened={isDialogOpened}>
            <DeliveryListComponent
                variables={{ id: deliveryListId, warehouseId: currentWarehouseId as string }}
                redirectOnErrorUrl={routePaths.warehouseDeliveryLists}
            >
                {({ data: { deliveryList } }) => {
                    return <DeliveryListDetailsView deliveryList={deliveryList} onClose={onClose} />;
                }}
            </DeliveryListComponent>
        </FullScreenDialog>
    );
};

export default DeliveryListDetails;